// extracted by mini-css-extract-plugin
module.exports = {"footer-container-placeholder":"_2RQLwL"};